// frontend/src/pages/supplierSetupLinks.js
//
// Where a drill-through into the Suppliers grid goes — the Suppliers twin of
// itemSetupLinks.js. The value rides an encoded route SEGMENT for the reason
// given there: tabs are keyed by pathname, so a query string matches no route.

// The Suppliers grid with its search box seeded to one supplier's name (Data
// Health's "Edit supplier"), so the row whose Days of supply target and Review
// frequency need a change is the one on screen.
export const suppliersForSupplierPath = (supplierName) =>
  `/supplier-setup/supplier/${encodeURIComponent(supplierName)}`;
